module.exports = __webpack_public_path__ + "static/img/xinhanfang.800468e9.jpg";